import * as React from "react";
import {
  Card,
  CardHeader,
  Avatar,
  Typography,
  Box,
  Container,
} from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Swiper modullarini faollashtiramiz
SwiperCore.use([Autoplay, Navigation, Pagination]);

const userTestimonials = [
  {
    name: "Akbarova Zuxro",
    occupation:
      "Filologiya fanlari doktori, Farg‘ona davlat universiteti professori",
    img: "assets/tes4.jpg",
  },
  {
    name: "Zokirova Sohiba Muxtoralievna",
    occupation: "Filologiya fanlari boʼyicha falsafa doktori",
    img: "assets/tes1.jpg",
  },
  {
    name: "Shaxobiddinova Shohida Xoshimovna",
    occupation: "Filologiya fanlari boʼyicha falsafa doktori",
    img: "assets/tes2.jpg",
  },
  {
    name: "Umarova Nargizaxon Rustamovna",
    occupation: "Filologiya fanlari doktori (DCs), FDU dotsenti",
    img: "assets/tes3.jpg",
  },

  {
    name: "Sobirova Zilolaxon Maxmudovna",
    occupation:
      "Nazariy asoslari hamda amaliy tadbiqi bo‘yicha ilmiy tadqiqot olib bormoqda",
    img: "assets/person4.jpg",
  },
];

const logoStyle = {
  width: "100%",
  height: "250px",
  borderRadius: "8px",
  objectFit: "cover" as const,
};

export default function Testimonials() {
  const { mode, systemMode } = useColorScheme();

  return (
    <Container
      id="testimonials"
      sx={{
        pb: { xs: 8, sm: 16 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          sx={{ color: "text.primary" }}
        >
          Bizning a’zolar
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          Platformaning asosiy ishchi guruhi va a’zolari
        </Typography>
      </Box>

      <Swiper
        spaceBetween={20}
        slidesPerView={2}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{ clickable: true }}
        navigation={true}
        breakpoints={{
          600: {
            slidesPerView: 2,
          },
          900: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 5,
          },
        }}
        style={{ width: "100%", paddingTop: "20px" }}
      >
        {userTestimonials.map((user, index) => (
          <SwiperSlide key={index}>
            <Card
              variant="outlined"
              sx={{
                height: "350px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <img src={user.img} alt={user.name} style={logoStyle} />
              <CardHeader
                avatar={""}
                title={<Box sx={{ fontSize: "15px" }}>{user.name}</Box>}
                subheader={
                  <Box sx={{ fontSize: "14px" }}>{user.occupation}</Box>
                }
              />
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
}
